<template>
<b-container fluid :class="$style.container">
  <b-row class="parent-row">
    <b-col cols="12" :class="$style.bodyContainer">
      <slot />
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss" module>
@import 'theme.scss';

.container {
  max-width: 100vw;
  min-width: 100vw;
}

.bodyContainer {
  height: 100vh;
  overflow: scroll;
  padding: 0;
}
</style>
